import React, { useCallback, useEffect, useState, Fragment } from 'react'
import {
  Row,
  Col,
  Button,
  Skeleton,
  Modal,
  Radio,
  Form,
  Input,
  Select,
  Space,
} from 'antd'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import {
  getPlans,
  submitPaymentInfo,
  updateSubscription,
  changePaymentMethod,
  changeEmail,
} from '../../Actions/Plans'
import PlanStatusHeading from '../../partials/PlanStatusHeading'

const { Option } = Select

const NUMBER_WORDS = [
  'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
]

const carrierCountLabel = (count) => {
  const n = Number(count)
  if (!n) return null
  const word = NUMBER_WORDS[n] || n
  return `${word} carrier${n === 1 ? '' : 's'}`
}

const planPeriodLabel = (plan) => {
  const trialDays = Number(plan.trial_days) || 0
  if (trialDays >= 365 && trialDays % 365 === 0) {
    const years = trialDays / 365
    return `${years} Year Trial`
  }
  if (trialDays > 0) {
    return `${trialDays} Day Trial`
  }
  return 'per month'
}

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
}

function PlansComponent() {
  const { plans, token, store, currentPlan, alertMessageType } = useSelector((state) => state)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [paymenyMethod, setPaymenyMethod] = useState(2)
  const [number, setNumber] = useState('')
  const [date, setDate] = useState('')
  const [cvc, setCvc] = useState('')
  const [country, setCountry] = useState(store?.country || '')
  const [zipCode, setZipCode] = useState('')
  const [name, setName] = useState(
    store ? [store.first_name, store.last_name].filter(Boolean).join(' ') : ''
  )
  const [email, setEmail] = useState(store?.admin_email || '')
  const [address, setAddress] = useState(store?.address || '')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [planid, setPlanid] = useState('')
  const [cancelSubsriptionVisible, SetCancelSubsriptionVisible] =
    useState(false)
  const [updatePaymentMethodCheck, SetUpdatePaymentMethodCheck] =
    useState(false)
  const [changeEmailVisible, setChangeEmailVisible] = useState(false)
  const [newEmail, setNewEmail] = useState('')
  const [trialVisible, SetTrialVisible] = useState(false)
  const [devPlanVisible, SetDevPlanVisible] = useState(false)
  const dispatch = useDispatch()
  

  function getGA4ClientId() {
    let clientId = localStorage.getItem("ga_client_id");
    if (!clientId) {
      const rand1 = Math.floor(Math.random() * 1e10);
      const rand2 = Math.floor(Math.random() * 1e10);
      clientId = `${rand1}.${rand2}`;
      localStorage.setItem("ga_client_id", clientId);
    }
    return clientId;
  }

  const clientId = getGA4ClientId();

  useEffect(() => {
    if (alertMessageType !== 'loading') {
      setIsLoading(false)
    }
  }, [alertMessageType])

  useEffect(() => {
    if (!plans) {
      dispatch(getPlans())
    }
  }, [dispatch, plans])

  const clearForm = useCallback(() => {
    if (store) {
      setNumber('')
      setDate('')
      setCvc('')
      setName([store.first_name, store.last_name].filter(Boolean).join(' '))
      setAddress(store.address)
      setEmail(store.admin_email)
      setCity('')
      setState('')
      setCountry(store.country)
      setZipCode('')
    }
  }, [store])

  const toggleModal = (id) => {
    clearForm()
    setIsLoading(false)
    setPlanid(id)

    if (id === 1) {
      SetTrialVisible(true)
      //dispatch(submitPaymentInfo({plan:1}, token, setIsModalVisible))
    } else if(id === 5) {
      SetDevPlanVisible(true)
    } else {
      setIsModalVisible(!isModalVisible)
    }
  }

  const activateTrialPlan = () => {
    if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(email)) {
      setIsLoading(true)
      dispatch(
        submitPaymentInfo(
          { plan: planid, email: email, client_id: clientId },
          token,
          planid == 5 ? SetDevPlanVisible : SetTrialVisible,
        )
      )
    } else {
      dispatch({
        type: 'ALERT_MESSAGE',
        payload: {
          showAlertMessage: false,
        },
      })
      dispatch({
        type: 'ALERT_MESSAGE',
        payload: {
          showAlertMessage: true,
          alertMessage: 'Enter valid email address',
          alertMessageType: 'error',
        },
      })
    }
  }

  const onFinish = (values) => {
    setIsLoading(true)
    if (updatePaymentMethodCheck) {
      const data = {
        ...values,
        card_number: number,
        date,
        exp_year: date.split('/')[1],
        exp_month: date.split('/')[0],
        cvc,
        card_name: name,
        address,
        city: city,
        state: state,
        country,
        zip: zipCode,
        plan: '',
        defaultpayment: false,
        client_id: clientId
      }
      dispatch(changePaymentMethod(data, token, SetUpdatePaymentMethodCheck))
      //SetUpdatePaymentMethodCheck(false);
    } else {
      if (+paymenyMethod === 1) {
        const data = {
          defaultpayment: true,
          client_id: clientId,
        }
        dispatch(submitPaymentInfo(data, token, setIsModalVisible))
      } else if (+paymenyMethod === 2) {
        const data = {
          ...values,
          card_number: number,
          date,
          exp_year: date.split('/')[1],
          exp_month: date.split('/')[0],
          cvc,
          card_name: name,
          email,
          address,
          city,
          state,
          country,
          zip: zipCode,
          plan: planid,
          defaultpayment: false,
          client_id: clientId,
        }
        dispatch(submitPaymentInfo(data, token, setIsModalVisible))
      }
      //setIsModalVisible(false)
    }
  }

  const updatePlan = useCallback(() => {
    setIsLoading(true)
    const data = {
      defaultpayment: true,
      plan: planid,
      client_id: clientId,
    }
    dispatch(submitPaymentInfo(data, token, setIsModalVisible))
  }, [dispatch, planid, token])

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', { ...errorInfo, country })
  }

  const formatAccountNumber = useCallback((inp) => {
    const text = inp.split(' ').join('')

    if (!isNaN(text)) {
      let formatted_number = ''

      for (let i = 0; i < text.length; i++) {
        if (i > 1 && i % 4 === 0) {
          formatted_number += ' ' + text[i]
          continue
        }

        formatted_number += text[i]
      }

      setNumber(formatted_number)
    }
  }, [])

  const formatExpiryDate = useCallback((date) => {
    const text = date.split('/').join('')
    const month = date.slice(0, 2)
    const year = date.split('/')[1]

    if (!isNaN(text)) {
      let formatted_date = ''

      if (+month > 12) {
        setDate('12')
        return
      }

      if (
        year &&
        year.length === 4 &&
        (+year < new Date().getFullYear() || +year > new Date().getFullYear() + 20)
      ) {
        setDate(month + '/20')
        return
      }

      if (+text[0] > 1) {
        formatted_date = '0' + text[0] + '/'
      } else {
        for (let i = 0; i < text.length; i++) {
          if (i > 1 && i < 3) {
            formatted_date += '/' + text[i]
            continue
          }

          formatted_date += text[i]
        }
      }
      setDate(formatted_date)
    }
  }, [])

  const toggleSubscription = useCallback(() => {
    const data = {
      cancel: currentPlan && currentPlan?.status === 2 ? 0 : 1,
      isSandboxStore: store?.plan_level && store?.plan_level == 'Sandbox Store' ? 1 : 0,
      client_id: clientId,
    }
    dispatch(updateSubscription(token, data))
    SetCancelSubsriptionVisible(false)
  }, [currentPlan, dispatch, token])

  // Move the last entry to the first index
  let rearrangedPlans = [];
  if(store?.plan_level == 'Sandbox Store'){
    rearrangedPlans = (() => {
      const devPlan = plans.find(p => p.id === 5); // Development plan goes first for sandbox stores
      return devPlan ? [devPlan, ...plans.filter(p => p.id !== 5)] : plans;
    })();
  } else {
    rearrangedPlans = plans
  }
  

  const updatePaymentMethod = useCallback(() => {
    clearForm()
    SetUpdatePaymentMethodCheck(true)
  }, [clearForm])

  return plans ? (
    <Fragment>
      <PlanStatusHeading />
      {((currentPlan?.plan_id == 1 && store?.plan_level == 'Sandbox Store') || currentPlan?.plan_id > 1) && currentPlan?.plan_id != 5 && (
        <Space className={'mb-3'}>
          {currentPlan.status !== 2 ? (
            <Button
              type='primary'
              onClick={() => SetCancelSubsriptionVisible(true)}
            >
              Cancel Subscription
            </Button>
          ) : (
            <Button type='primary' onClick={() => toggleSubscription(true)}>
              Undo Cancel Subscription
            </Button>
          )}

          {store?.plan_level != 'Sandbox Store' && (
            <Button type='primary' onClick={updatePaymentMethod}>
              Change Payment Method
            </Button>
          )}

          {store?.plan_level != 'Sandbox Store' && (
            <Button type='primary' onClick={() => { setNewEmail(currentPlan?.email || store?.admin_email || ''); setChangeEmailVisible(true); }}>
              Change Email Address
            </Button>
          )}

          <Modal
            title='Cancel Subscription'
            visible={cancelSubsriptionVisible}
            onCancel={() => SetCancelSubsriptionVisible(false)}
            centered
            onOk={() => toggleSubscription()}
            okText='Confirm'
            cancelButtonProps={{ style: { display: 'none' } }}
          >
            Are you sure you want to cancel subscription?
          </Modal>

          <Modal
            title='Change Email Address'
            visible={changeEmailVisible}
            onCancel={() => setChangeEmailVisible(false)}
            centered
            onOk={() => {
              if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(newEmail)) {
                dispatch(changeEmail({ email: newEmail }, token, setChangeEmailVisible))
              } else {
                dispatch({
                  type: 'ALERT_MESSAGE',
                  payload: {
                    showAlertMessage: true,
                    alertMessage: 'Enter a valid email address',
                    alertMessageType: 'error',
                  },
                })
              }
            }}
            okText='Update'
            confirmLoading={alertMessageType === 'loading'}
            okButtonProps={{ disabled: alertMessageType === 'loading' }}
          >
            <Row gutter={24}>
              <Col span={6}>Email</Col>
              <Col span={18}>
                <Input
                  name='email'
                  type='email'
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder='Enter new email address'
                />
              </Col>
            </Row>
          </Modal>
        </Space>
      )}
      <Space>
        <Modal
          title= {devPlanVisible ? 'Development Plan' : 'Trial Plan'}
          visible={trialVisible || devPlanVisible}
          onCancel={() => {SetTrialVisible(false); SetDevPlanVisible(false);}}
          centered
          onOk={() => activateTrialPlan()}
          okText='Activate'
          confirmLoading={isLoading}
          okButtonProps={{ disabled: isLoading }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Row gutter={24}>
            <Col span={6}>Email</Col>
            <Col span={18}>
              <Input
                name='email'
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Col>
          </Row>
        </Modal>
      </Space>
      <Space direction='vertical' size={'large'} className={'w-100'}>
        <Row gutter={30}>
          <Modal
            title='Payment Information'
            visible={isModalVisible}
            onCancel={toggleModal}
            centered
            footer={null}
            // width={700}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
          >
            {currentPlan?.plan_id > 1 && currentPlan?.plan_id != 5 && (
              <>
                <p>Default payment method</p>
                <Radio
                  checked={paymenyMethod === 1}
                  onChange={() => setPaymenyMethod(1)}
                >
                  **** **** **** {currentPlan?.last4}
                </Radio>
                <p className='mt-2'>Add new payment method</p>
                <Radio
                  checked={paymenyMethod === 2}
                  onChange={() => setPaymenyMethod(2)}
                >
                  Add Card
                </Radio>
              </>
            )}

            {paymenyMethod === 2 ? (
              <Form
                {...layout}
                name='payment-form'
                initialValues={{
                  city: '',
                  state: '',
                  requiredMark: true,
                }}
                // defaultValue=''
                onFinish={onFinish}
                requiredMark
                //onFinishFailed={onFinishFailed}
                className='mt-2'
              >
                <h3>Card Information</h3>
                <Form.Item
                  label={`Number`}
                  rules={[
                    {
                      required: true,
                      message: 'Please input your card number!',
                    },
                  ]}
                >
                  <Input
                    type='tel'
                    name='number'
                    maxlength='23'
                    required
                    value={number}
                    onChange={(e) => formatAccountNumber(e.target.value)}
                  />
                  <div className={'text-gray'}>e.g. xxxx xxxx xxxx xxxx</div>
                </Form.Item>

                <Form.Item
                  label='MM/YYYY'
                  required
                  rules={[
                    {
                      required: true,
                      message: 'Please input your MM/YYYY!',
                    },
                  ]}
                >
                  <Input
                    type='text'
                    name='date'
                    maxlength='7'
                    pattern='(?:0[1-9]|1[0-2])/[0-9]{4}'
                    placeholder='xx/xxxx'
                    required
                    value={date}
                    onChange={(e) => {
                      formatExpiryDate(e.currentTarget.value)
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label='CVC'
                  required
                  rules={[
                    {
                      required: true,
                      message: 'Please input your CVC',
                    },
                  ]}
                >
                  <Input
                    type='number'
                    name='cvc'
                    maxlength='4'
                    pattern='\d{4}$'
                    required
                    max='only 4 digits'
                    value={cvc}
                    onChange={(e) => {
                      if (e.target.value.length < 5) {
                        setCvc(e.target.value)
                      }
                    }}
                  />
                </Form.Item>

                <h3>Billing Details</h3>
                <Form.Item
                  label='Card Holder Name'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input card holder name',
                    },
                  ]}
                >
                  <Input
                    name='name'
                    value={name}
                    required
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  label='Address'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your address',
                    },
                  ]}
                >
                  <Input
                    name='address'
                    value={address}
                    type='text'
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </Form.Item>

                <Form.Item
                  label='Email'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your email',
                    },
                  ]}
                >
                  <Input
                    name='email'
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Item>

                <Form.Item
                  label='City'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your city',
                    },
                  ]}
                >
                  <Input
                    defaultValue=''
                    name='city'
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    required
                  />
                </Form.Item>

                <Form.Item
                  label='State'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your state',
                    },
                  ]}
                >
                  <Input
                    name='state'
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    defaultValue=''
                    required
                  />
                </Form.Item>

                <Form.Item label='Country'>
                  <Select
                    defaultValue='united states'
                    name='country'
                    onChange={(opt) => setCountry(opt)}
                    value={country}
                    required
                  >
                    <Option value='united states'>United States</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label='Zip'
                  required
                  rules={[
                    {
                      required: true,
                      message: 'Please input your zip code!',
                    },
                  ]}
                >
                  <Input
                    type='number'
                    name='zip'
                    maxLength='5'
                    pattern='\d{5}$'
                    value={zipCode}
                    onChange={(e) => {
                      if (e.target.value.length < 6) {
                        setZipCode(e.target.value)
                      }
                    }}
                    required
                  />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button type='primary' htmlType='submit' loading={isLoading} disabled={isLoading}>
                    Change Plan
                  </Button>
                </Form.Item>
              </Form>
            ) : (
              <Row gutter={24}>
                <Col span={24} className={'m-4'}>
                  <Button
                    className={'mt-3'}
                    type='primary'
                    onClick={updatePlan}
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            )}
          </Modal>
        </Row>

        {updatePaymentMethodCheck && (
          <Row gutter={30}>
            <Modal
              title='Payment Information'
              visible={updatePaymentMethodCheck}
              onCancel={() => SetUpdatePaymentMethodCheck(false)}
              centered
              footer={null}
              // width={700}
              okButtonProps={{ style: { display: 'none' } }}
              cancelButtonProps={{ style: { display: 'none' } }}
            >
              <Form
                {...layout}
                name='basic'
                initialValues={{ city: '', state: '' }}
                defaultValue=''
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className='mt-2'
              >
                <h3>Card Information</h3>
                <Form.Item
                  label='Number'
                  required
                  requiredMark
                  rules={[
                    {
                      required: true,
                      message: 'Please input your card number!',
                    },
                  ]}
                >
                  <Input
                    type='tel'
                    name='number'
                    maxlength='23'
                    required
                    value={number}
                    onChange={(e) => formatAccountNumber(e.target.value)}
                  />
                  <div className={'text-gray'}>e.g. xxxx xxxx xxxx xxxx</div>
                </Form.Item>

                <Form.Item
                  label='MM/YY'
                  required
                  requiredMark
                  rules={[
                    {
                      required: true,
                      message: 'Please input your MM/YY!',
                    },
                  ]}
                >
                  <Input
                    type='text'
                    name='date'
                    maxlength='7'
                    pattern='(?:0[1-9]|1[0-2])/[0-9]{4}'
                    placeholder='xx/xxxx'
                    required
                    value={date}
                    onChange={(e) => {
                      formatExpiryDate(e.currentTarget.value)
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label='CVC'
                  required
                  rules={[
                    {
                      required: true,
                      message: 'Please input your CVC',
                    },
                  ]}
                >
                  <Input
                    type='number'
                    name='cvc'
                    maxlength='4'
                    pattern='\d{4}$'
                    required
                    max='only 4 digits'
                    value={cvc}
                    onChange={(e) => {
                      if (e.target.value.length < 5) {
                        setCvc(e.target.value)
                      }
                    }}
                  />
                </Form.Item>

                <h3>Billing Details</h3>
                <Form.Item
                  label='Card Holder Name'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input card holder name',
                    },
                  ]}
                >
                  <Input
                    name='name'
                    value={name}
                    required
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  label='Address'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your address',
                    },
                  ]}
                >
                  <Input
                    name='address'
                    value={address}
                    type='text'
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </Form.Item>

                <Form.Item
                  label='City'
                  name='city'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your city',
                    },
                  ]}
                >
                  <Input defaultValue='' required />
                </Form.Item>

                <Form.Item
                  label='State'
                  name='state'
                  required
                  rules={[
                    {
                      required: true,
                      message: ' Please input your state',
                    },
                  ]}
                >
                  <Input defaultValue='' required />
                </Form.Item>

                <Form.Item label='Country'>
                  <Select
                    defaultValue='united states'
                    name='country'
                    onChange={(opt) => setCountry(opt)}
                    value={country}
                    required
                  >
                    <Option value='usa'>United States</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label='Zip'
                  required
                  rules={[
                    {
                      required: true,
                      message: 'Please input your zip code!',
                    },
                  ]}
                >
                  <Input
                    type='number'
                    name='zip'
                    maxLength='5'
                    pattern='\d{5}$'
                    value={zipCode}
                    onChange={(e) => {
                      if (e.target.value.length < 6) {
                        setZipCode(e.target.value)
                      }
                    }}
                    required
                  />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button type='primary' htmlType='submit' loading={isLoading} disabled={isLoading}>
                    Change
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
          </Row>
        )}
      </Space>

      <p className='plans-intro'>Select a plan that meets your needs.</p>

      <Row gutter={24} wrap={false} className='plans-row'>
        {rearrangedPlans.map((plan, i) =>
          (plan.id === 1 && currentPlan?.plan_id > 1) || (plan.id === 1 && store?.plan_level == 'Sandbox Store') ||
          (plan.id === 5 && store?.plan_level != 'Sandbox Store') || (plan.id === 5 && currentPlan?.plan_id && currentPlan?.plan_id != 5) ||
          (plan.id === 5 && currentPlan?.plan_id && currentPlan?.status === 2) ||
          ((plan.id === 1 || (plan.name + '').toLowerCase() === 'trial') &&
            currentPlan?.plan_id === 1 &&
            currentPlan?.status === 2) ? null : (
            <Col
              className='gutter-row mb-3 plans-col'
              key={i}
            >
              <div className={'pricing-box'}>
                <div className='pricing-header'>
                  <h2>{(plan.name + '').trim()}</h2>
                  <div className='plan-price'>
                    <span className='plan-price-amount'>${plan.price}</span>
                    <span className='plan-price-currency'>USD</span>
                  </div>
                  <p className='plan-period'>{planPeriodLabel(plan)}</p>
                  {carrierCountLabel(plan.carrier_count) && (
                    <p className='plan-highlight'>{carrierCountLabel(plan.carrier_count)}</p>
                  )}
                  {currentPlan?.plan_id === plan.id &&
                  !currentPlan?.is_expired ? (
                    <Button size={'large'} className='plan-select-btn plan-select-btn--active' disabled>
                      Active Plan
                    </Button>
                  ) : (
                    <Button
                      size={'large'}
                      type='primary'
                      className='plan-select-btn'
                      onClick={() => toggleModal(plan.id)}
                      disabled={store?.plan_level == 'Sandbox Store' && plan.id !== 5}
                    >
                      Select
                    </Button>
                  )}
                </div>
              </div>
            </Col>
          )
        )}
      </Row>

      <div className='features-section mt-3'>
        <h2 className='features-banner'>Features</h2>
        <div className='features-body'>
          <p className='features-intro'>
            The DIY Real Time Shipping Quotes app includes integrations for many shipping
            providers. The list below is a compilation of generally available features. Some
            features are not available in all integrations. Verify the availability of
            particular features of interest by consulting the User Guide or by sending an
            inquiry to support@eniture.com.
          </p>

          <h3>Features common to parcel and freight</h3>
          <ul className='features-list'>
            <li>Real-time, account-specific shipping quotes.</li>
            <li>Mark up or down quoted shipping rates by dollar amount or percentage.</li>
            <li>Select which services to offer to customers.</li>
            <li>Define multiple warehouse locations.</li>
            <li>Quote shipping for items that drop-ship from vendors.</li>
            <li>Auto-detect residential address for accurate inclusion of related fees.</li>
            <li>Suppress shipping quotes from parcel and freight providers when the ship-to address is a post office box.</li>
            <li>Choose how to convey estimated delivery dates to shoppers.</li>
            <li>Influence delivery date estimates by identifying the daily order cut-off time.</li>
            <li>Built-in shipment date offset days for long lead times.</li>
            <li>Record the length, width, and height of items and variants.</li>
            <li>Offer a local delivery option when the delivery address is within a specified distance to the shipment origin.</li>
            <li>Offer in-store pickup as an option when the shopper is within a specified distance from the shipment origin.</li>
            <li>Implement shipping rules to alter the behavior and outcomes of the app.</li>
            <li>Bulk update product shipping parameters through the provided CSV utility or Application Programming Interface (API).</li>
            <li>Identify the packing attributes of products that will nest inside of one another when packaged for shipping.</li>
            <li>Opt to include insurance cost in shipping quotes.</li>
            <li>Enable logs to see the API Request and Response details processed by the app.</li>
            <li>Seamless integration to FreightDesk Online</li>
          </ul>

          <h3>Parcel specific features</h3>
          <ul className='features-list'>
            <li>Accurate shipping quotes based on parcel carrier rules for billable weight, which is the greater of the actual or dimensional weight.</li>
            <li>Choose to include signature or adult-signature fees in quoted shipping rates.</li>
            <li>Suppress ground service based on the transit time estimate. (Important for perishable items.)</li>
            <li>Advanced packaging algorithm generates super-accurate shipping rates by identifying the best packaging solution using merchant defined box sizes.</li>
          </ul>

          <h3>Freight specific features</h3>
          <ul className='features-list'>
            <li>Identify items in the product catalog that can only ship with an LTL freight carrier.</li>
            <li>Choose to enable guaranteed service options.</li>
            <li>Record the freight class and NMFC number of items and variants.</li>
            <li>Use the density calculation setting for items whose freight class is density based.</li>
            <li>
              Select the desired settings for the following LTL freight additional services:
              <ul className='features-sublist'>
                <li>Hold at terminal</li>
                <li>Inside delivery</li>
                <li>Lift gate delivery</li>
                <li>Limited access delivery</li>
                <li>Notify before delivery</li>
                <li>Residential delivery</li>
              </ul>
            </li>
            <li>Set the weight threshold for when LTL freight should also be quoted for carts that have a large quantity of items that usually ship with a parcel carrier.</li>
            <li>Identify the weight and weight capacity of a representative handling unit (e.g. pallet) so that its incremental cost for shipping is incorporated into the quoted shipping rate.</li>
            <li>Implement the optional pallet packing packaging algorithm if the pricing tariff with the LTL freight provider requires that shipments be rated dimensionally.</li>
          </ul>
        </div>
      </div>
    </Fragment>
  ) : (
    <Skeleton />
  )
}

export default PlansComponent
